import React from 'react';
import ReactScene from 'react-scene';

import { loadTextures, clearTextures } from '../../lib/loadTextures';
import Scene from '../views/Scene.jsx';

import createSprite from '../../lib/createSprite';
import spritesHelper from '../../lib/spritesHelper';
import Utils from '../../lib/utils';

import GuillotineAnimations from '../../animations/guillotine';

// Scene data
import TooBigObjects from '../../objects/toobig';

// Frames
import SlotMachineBig from '../frames/C-TooBig/2-SlotMachineBig.jsx';
import Ministre from '../frames/C-TooBig/4-SoloFunnel.jsx';
import Family from '../frames/A-Remuneration/3-FamilyPump.jsx';

var TooBig = React.createClass({

    propTypes: {
        name: React.PropTypes.string,
        width: React.PropTypes.number,
        height: React.PropTypes.number,

        frameWidth: React.PropTypes.number,
        frameHeight: React.PropTypes.number,

        storiesContainer: React.PropTypes.object,

        mouseDown: React.PropTypes.bool,
        mouseMove: React.PropTypes.bool,
        mouseClientX: React.PropTypes.number,
        mouseClientY: React.PropTypes.number,
        mouseWheelX: React.PropTypes.number,
        mouseWheelY: React.PropTypes.number
    },

    contextTypes: {
        intensity: React.PropTypes.number,
        minIntensity: React.PropTypes.number,
        maxIntensity: React.PropTypes.number
    },

    getDefaultProps: function()
    {
        return {
            framesClasses: [SlotMachineBig, Ministre, Family],
            framesRenderExceptions: {
            },
        };
    },

    sprites: null,
    mainTimeline: null,
    charlesSlotMachineTimelines: null,

    getInitialState: function()
    {
        return {
            objectsWithTextures: null,
            mainContainer: null,
            loadedProgress: 0
        };
    },

    render: function()
    {
        var props = this.props;
        var state = this.state;
        var context = this.context;

        return (
            <Scene
                intensity={context.intensity}
                mainContainer={state.mainContainer}
                objectsWithTextures={state.objectsWithTextures}
                loadedProgress={state.loadedProgress}
                {...props}
            />
        );
    },

    /*
     * React life cycle
     */

    componentDidMount: function()
    {
        this.mainTimeline = new TimelineMax({
            paused: true
        });
    },

    componentDidUpdate: function(prevProps, prevState, prevContext)
    {
        var intensityChanged = prevContext.intensity !== this.context.intensity;
        if (intensityChanged)
        {
            this.updateIntensity(prevContext.intensity);
        }
    },

    componentWillUnmount: function()
    {
        if (this.mainTimeline)
        {
            this.mainTimeline.pause();
            this.mainTimeline.kill();
            this.mainTimeline = null;
        }
    },

    /*
     * Scene life cycle
     */

    load: function(e)
    {
        var done = e.async();

        var onTexturesLoaded = _.bind(function(objectsWithTextures)
        {
            this.setState({
                objectsWithTextures: objectsWithTextures
            }, done)
        }, this);

        clearTextures(Object.keys(TooBigObjects));

        loadTextures(TooBigObjects, this.onTextureLoaded)
            .then(onTexturesLoaded);
    },

    build: function(e)
    {
        var mainContainer = new PIXI.Container();
        this.props.storiesContainer.addChild(mainContainer);
        this.sprites = {};

        this.setState({
            mainContainer: mainContainer
        }, function(){
            this.buildObjects();
            this.animateObjects();
            this.updateIntensity();
        });
    },

    play: function(e)
    {
        if (this.mainTimeline)
        {
            this.mainTimeline.play();
        }
    },

    pause: function(e)
    {
        if (this.mainTimeline)
        {
            this.mainTimeline.pause();
        }
    },

    destroy: function(e)
    {

    },

    resize: function(e)
    {

    },

    /*
     * Methods
     */

    buildObjects: function()
    {
        var props = this.props;
        var state = this.state;
        var sprites = this.sprites;

        var frameWidth = props.frameWidth;
        var frameHeight = props.frameHeight;
        var frameBorder = props.frameBorder;
        var mainContainer = state.mainContainer;
        var objs = state.objectsWithTextures;

        var ropeObj = objs.rope;

        // var background2 = mainContainer.getChildByName('background2');
        //
        // // rope left
        // var ropeLeft = sprites.ropeLeft = spritesHelper.buildRope(ropeObj, mainContainer, background2, ropeObj.left);
        //
        // // guillotine
        // var guillotineObj = objs.guillotine;
        // var guillotine = sprites.guillotine = createSprite(guillotineObj);
        // Utils.setSizeAndPositionFromRefSprite(guillotine, background2, guillotineObj);
        //
        // // rope top
        // var ropeTop = sprites.ropeTop = spritesHelper.buildRope(ropeObj, mainContainer, background2, ropeObj.top);
        //
        // // wheels
        // var wheelObj = objs.wheel;
        // var wheelLeft = sprites.wheelLeft = createSprite(wheelObj);
        // Utils.setSizeAndPositionFromRefSprite(wheelLeft, background2, wheelObj);
        //
        // var wheelRight = sprites.wheelRight = createSprite(wheelObj);
        // Utils.setSizeAndPositionFromRefSprite(wheelRight, background2, wheelObj);
        //
        // mainContainer.addChild(guillotine);
        // mainContainer.addChild(wheelRight);
    },

    animateObjects: function()
    {
        // var state = this.state;
        // var animations = this.animations;
        // var sprites = this.sprites;
        //
        // var wheelLeft = sprites.wheelLeft;
        // var wheelRight = sprites.wheelRight;
        // var guillotine = sprites.guillotine;
        // var ropeLeft = sprites.ropeLeft;
        // var ropeTop = sprites.ropeTop;
        // // var ropeRight = sprites.ropeRight;
        // var ropePixels = state.mainContainer.getChildByName('background2').height * 0.06;
        //
        // var guillotineTimeline = this.guillotineTimeline = GuillotineAnimations.getGuillotineTimeline({
        //     leftElements: [ropeLeft, guillotine],
        //     topElements: ropeTop,
        //     // rightElements: ropeRight,
        //     wheels: [wheelRight],
        //     pixels: ropePixels,
        //     rotation: -30
        // });
        //
        // this.mainTimeline.add(guillotineTimeline);
        //
        // this.mainTimeline.pause();
        // this.mainTimeline.play(); // devrait être callé par le play, après le build
    },

    /*
     * Event handlers
     */

    updateIntensity: function(prevIntensity)
    {
        var context = this.context;
        prevIntensity = typeof prevIntensity !== 'undefined' ? prevIntensity:context.intensity;

        var intensity = context.intensity;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;

        var intensityChanged = prevIntensity !== intensity;

        if (this.guillotineTimeline) {
            // this.guillotineTimeline.pause();
            // var timeline = new TimelineMax();
            // var progress = (intensity - minIntensity) * 0.8 / (maxIntensity - minIntensity);
            //
            // TweenMax.killTweensOf(this.guillotineTimeline);
            //
            // timeline.to(this.guillotineTimeline, intensityChanged ? 2:0, {
            //     progress: progress,
            //     ease: Quad.easeOut
            // });
            // timeline.to(this.guillotineTimeline, 1, {
            //     repeat: -1,
            //     yoyo: true,
            //     progress: '+=0.2',
            //     ease: Quad.easeInOut
            // });
        }

    },

    onTextureLoaded: function(data)
    {
        this.setState({
            loadedProgress: data.progress
        });
    }
});

module.exports = ReactScene.createScene(TooBig);



// WEBPACK FOOTER //
// ./js/components/scenes/C-Toobig.jsx